<script setup lang="ts">
//#region imports
import { nextTick, ref, watch } from 'vue';
//#endregion

//#region types
interface Props {
  width?: string;
  height?: string;
  html?: string;
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  width: '100%',
  height: '100%',
  html: '',
});
//#endregion

//#region state
const iframe = ref<HTMLIFrameElement | null>(null);
//#endregion

//#region methods
function setIframeHtml(target: HTMLIFrameElement, html: string): void {
  const documentRef = target.contentWindow?.document;
  if (!documentRef) {
    return;
  }

  documentRef.open();
  documentRef.write(html);
  documentRef.close();
};
//#endregion

//#region watch
watch(
  () => props.html,
  async (value) => {
    const target = iframe.value;
    if (target) {
      setIframeHtml(target, value);
      return;
    }

    await nextTick();
    if (iframe.value) {
      setIframeHtml(iframe.value, value);
    }
  },
  { immediate: true },
);
//#endregion
</script>

<template>
  <iframe
    ref="iframe"
    :width="props.width"
    :height="props.height"
  />
</template>
